import { checkNbOfMonthsSinceLastDisplay, getLatestDateRelancePrelevement } from '../../../modules/contracts/contractMapper'
import { PRL_AUTO } from '../../../enums/contractsEnum'
import { subCategoryEnum } from '../../../enums/makeRequestEnum'
import { ContractsModel } from '../../../types/contracts/contractsModel'
import { RequestItemModel } from '../../../modules/requests/requestsModel'

export const canDisplayCustomAlert = (contracts: ContractsModel[], requests: RequestItemModel[]) => {
	return hasPaymentModeDifferent(contracts, requests) && checkNbOfMonthsSinceLastDisplay(getLatestDateRelancePrelevement(contracts).dateRelancePrelevement)
}

//Check if one contract with payment mode different from PRL_AUTO, and there is no request in progress for subscription for bill debit
const hasPaymentModeDifferent = (contracts: ContractsModel[], requests: RequestItemModel[]) => {
	return contracts.filter(contract => contract.typeDePaiement !== PRL_AUTO).length > 0 &&	requests.filter(request => request.category === subCategoryEnum.bill.debit && !request.cloture).length === 0
}
